const MarketingSSO = () => 
  import(/* webpackChunkName: 'MarketingSSO' */ '@/Authentication/marketing-sso/Index.vue');

export default [
  {
    path: '/marketing-sso',
    name: 'marketing-sso',
    component: MarketingSSO,
  },
];
